import {createContext} from "react";

const AddCouponContext = createContext();

export default AddCouponContext;
